import React, { useState } from 'react';
import EditIcon from '@material-ui/icons/Edit';
import { IconButton } from '@material-ui/core';

import { EditCellProps } from './types';
import { AssignorRegistration } from '../assignorRegistration';

export const EditCell = ({ row, personIdLogged }: EditCellProps) => {
  const [showModalEdit, setShowModalEdit] = useState(false);
  const handleOpenModalEdit = () => setShowModalEdit(true);
  const handleCloseModalEdit = () => {
    setShowModalEdit(false);
  };

  return (
    <>
      <AssignorRegistration
        editMode={true}
        assignorData={row}
        personIdLogged={personIdLogged}
        isAssinorRegistrationModalOpen={showModalEdit}
        onClose={handleCloseModalEdit}
      />
      <IconButton onClick={() => handleOpenModalEdit()} disabled={row.strike} style={{ cursor: 'pointer' }}>
        <EditIcon />
      </IconButton>
    </>
  );
};
